import Vue from 'vue';
import Schedule from './schedule';
import { loadLanguageAsync } from '@/i18n'

// TODO extract global
function _cleanObj(obj) {
    for (var propName in obj) {
        if (obj[propName] === null || obj[propName] === undefined) {
            delete obj[propName];
        }
    }
    return obj
}

export default {
    namespaced: true,
    // -----------------------------------------------------------------
    state: {
        user: null,
        isLoggedIn: !!localStorage.getItem('sts-token'),
        isImpersonating: !!localStorage.getItem('sts-impersonate-token'),
        impersonate: JSON.parse(localStorage.getItem('sts-impersonate-token') || '{}') || null,
        token: JSON.parse(localStorage.getItem('sts-token') || '{}') || null,
        notifications: []
    },
    // -----------------------------------------------------------------
    getters: {
        currentUser: (state) => { return state.user },
        isLoggedIn: (state) => { return state.isLoggedIn },
        isImpersonating: (state) => { return state.isImpersonating },
        notifications: (state) => {
            return state.notifications.sort(function (a, b) {
                var keyA = new Date(a.created_at),
                    keyB = new Date(b.created_at);
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
                return 0;
            });
        },
    },
    // -----------------------------------------------------------------
    mutations: {
        LOGIN(state, credentials) {
            state.isLoggedIn = true
            state.token = credentials
            localStorage.setItem('sts-token', JSON.stringify(credentials));
        },
        LOGOUT(state) {
            state.isLoggedIn = false
            state.isImpersonating = false
            state.token = null
            state.impersonate = null
            localStorage.removeItem('sts-token');
            localStorage.removeItem('sts-impersonate-token');
            localStorage.removeItem('sts-data');
            Schedule.mutations.RESET(Schedule.state)
        },
        SET_CURRENT_USER(state, user) {
            if (user.user) {
                Schedule.mutations.SET_CURRENT_WEEK(Schedule.state, user.user.recommended_week)
            }
            if (user.locale) {
                loadLanguageAsync(user.locale)
                localStorage.setItem('sts-lang', user.locale)
            }
            state.user = user
        },
        IMPERSONATE(state, token) {
            state.isImpersonating = true;
            state.impersonate = token;
            localStorage.setItem('sts-impersonate-token', JSON.stringify(token));
        },
        STOP_IMPERSONATE(state) {
            state.isImpersonating = false;
            state.impersonate = null;
            localStorage.removeItem('sts-impersonate-token');
        },
        SET_CURRENT_USER_PROFESSION(state, profession_id) {
            state.user.user.profession_id = profession_id
        },
        SET_CURRENT_USER_SLEEP_INFO(state, sleep_info_id) {
            state.user.user.sleep_info_id = sleep_info_id
        },
        SET_CURRENT_USER_PERSONAL_INFO(state, personal_info_id) {
            state.user.user.personal_info_id = personal_info_id
        },
        SET_CURRENT_USER_MEDICAL_INFO(state, medical_info_id) {
            state.user.user.medical_info_id = medical_info_id
        },
        SET_CURRENT_USER_HABITS(state, habit_id) {
            state.user.user.habit_id = habit_id
        },
        SET_NOTIFICATIONS(state, notifications) {
            state.notifications = notifications
        },
        SET_CURRENT_USER_USER(state, user) {
            state.user.phone = user.phone
            state.user.first_name = user.first_name
            state.user.last_name = user.last_name
            state.user.locale = user.locale
            state.user.user.newsletter = user.newsletter
        }
    },
    // -----------------------------------------------------------------
    actions: {
        // -----------------------------------------------------------------
        // USER SPECIFIC
        // C.R.U.D.
        // Login / Logout
        // -----------------------------------------------------------------
        create: (context, userData) => {
            return Vue.api.post('register', userData)
                .then(response => {
                    context.commit('SET_CURRENT_USER', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        me: context => {
            return Vue.api.get('me')
                .then(response => {
                    context.commit('SET_CURRENT_USER', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        update: (context, { user_id, data }) => {
            return Vue.api.put(`user-profiles/${user_id}`, data)
                .then(response => {
                    context.commit('SET_CURRENT_USER_USER', response.data.data)
                })
                .catch(error => { throw error.response.data.error })
        },
        login: (context, credentials) => {
            return Vue.api.post('login', credentials)
                .then(response => {
                    context.commit('LOGIN', { token: response.data.data.token, refresh_token: response.data.data.refresh_token })
                    Vue.api.defaults.headers.common['X-Access-Token'] = response.data.data.token
                })
                .catch(error => { throw error.response.data.error })
        },
        logout: context => {
            context.commit('LOGOUT')
        },
        impersonate: (context, accountId) => {

            Vue.api.defaults.headers.common['X-Access-Impersonate-Token'] = context.state.token.token;

            if (!context.state.isImpersonating) {
                context.commit('IMPERSONATE', context.state.token)
            }

            return Vue.api.post(`account/${accountId}/impersonate`)
                .then(response => {
                    context.commit('LOGIN', { token: response.data.data.token, refresh_token: null })
                    Vue.api.defaults.headers.common['X-Access-Token'] = response.data.data.token
                })
                .catch(error => {
                    Vue.api.defaults.headers.common['X-Access-Impersonate-Token'] = null
                    context.commit('STOP_IMPERSONATE')
                    throw error.response.data.error
                })
        },
        stopImpersonating: context => {
            Vue.api.defaults.headers.common['X-Access-Impersonate-Token'] = null;
            Vue.api.defaults.headers.common['X-Access-Token'] = context.state.impersonate.token

            context.commit('LOGIN', context.state.impersonate)
            context.commit('STOP_IMPERSONATE')
        },
        passwordForgot: (context, data) => {
            return Vue.api.post('password/forgot', data)
                .then(response => {
                    return response.message
                })
                .catch(error => { throw error.response.data.error })
        },
        passwordReset: (context, data) => {
            return Vue.api.post('password/reset', data)
                .then(response => {
                    context.commit('LOGIN', { token: response.data.data.token, refresh_token: response.data.data.refresh_token })
                })
                .catch(error => { throw error.response.data.error })
        },
        changePassword: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/password`, data)
                .then(response => {
                    return response.message
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER PROFESSTION SPECIFIC
        // C.R.U.
        // -----------------------------------------------------------------
        createProfession: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/professions`, data)
                .then(response => {
                    context.commit('SET_CURRENT_USER_PROFESSION', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },
        readProfession: (context, { user_id, id }) => {
            return Vue.api.get(`users/${user_id}/professions/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateProfession: (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/professions/${data.id}`, data)
                .then(response => {
                    context.commit('SET_CURRENT_USER_PROFESSION', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER SLEEP INFO SPECIFIC
        // C.R.U.
        // -----------------------------------------------------------------
        createSleepInfo: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/sleep-info`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_SLEEP_INFO', response.data.data.id)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        readSleepInfo: (context, { user_id, id }) => {
            return Vue.api.get(`users/${user_id}/sleep-info/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateSleepInfo: (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/sleep-info/${data.id}`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_SLEEP_INFO', response.data.data.id)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER PERSONAL INFO SPECIFIC
        // C.R.U.
        // -----------------------------------------------------------------
        createPersonalInfo: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/personal-info`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_PERSONAL_INFO', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },
        readPersonalInfo: (context, { user_id, id }) => {
            return Vue.api.get(`users/${user_id}/personal-info/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updatePersonalInfo: async (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/personal-info/${data.id}`, data)
                .then(response => {
                    context.commit('SET_CURRENT_USER_PERSONAL_INFO', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER PSYCHOLOGICAL COMPLAINTS SPECIFIC
        // CD
        // -----------------------------------------------------------------
        createPsychologicalComplaints: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/psychological-complaints`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        deletePsychologicalComplaints: (context, { user_id, complaint_id }) => {
            return Vue.api.delete(`users/${user_id}/psychological-complaints/${complaint_id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        // -----------------------------------------------------------------
        // USER MEDICAL COMPLAINTS SPECIFIC
        // CD
        // -----------------------------------------------------------------
        createMedicalComplaints: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/medical-complaints`, data)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        deleteMedicalComplaints: (context, { user_id, complaint_id }) => {
            return Vue.api.delete(`users/${user_id}/medical-complaints/${complaint_id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER MEDICAL INFO SPECIFIC
        // C.R.U.
        // -----------------------------------------------------------------
        createMedicalInfo: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/medical-info`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_MEDICAL_INFO', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },
        readMedicalInfo: (context, { user_id, id }) => {
            return Vue.api.get(`users/${user_id}/medical-info/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateMedicalInfo: (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/medical-info/${data.id}`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_MEDICAL_INFO', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER MEDICAL INFO SPECIFIC
        // C.R.U.
        // -----------------------------------------------------------------
        createPsychologistNote: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/psychologist-notes`, _cleanObj(data))
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updatePsychologistNote: (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/psychologist-notes/${data.id}`, _cleanObj(data))
                .then(response => {
                    return response.data.data.id
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER Habits SPECIFIC
        // C.R.U.
        // -----------------------------------------------------------------
        createHabitsInfo: (context, { user_id, data }) => {
            return Vue.api.post(`users/${user_id}/habits`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_HABITS', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },
        readHabitsInfo: (context, { user_id, id }) => {
            return Vue.api.get(`users/${user_id}/habits/${id}`)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateHabitsInfo: (context, { user_id, data }) => {
            return Vue.api.put(`users/${user_id}/habits/${data.id}`, _cleanObj(data))
                .then(response => {
                    context.commit('SET_CURRENT_USER_HABITS', response.data.data.id)
                })
                .catch(error => { throw error.response.data.error })
        },

        // -----------------------------------------------------------------
        // USER notifications
        // -----------------------------------------------------------------
        readNotifications: (context, user_id) => {
            return Vue.api.get(`users/${user_id}/notifications`)
                .then(response => {
                    context.commit('SET_NOTIFICATIONS', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        updateNotifications: (context, { user_id, data }) => {
            return Vue.api.patch(`users/${user_id}/notifications`, data)
                .then(response => {
                    context.commit('SET_NOTIFICATIONS', response.data.data)
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        },
        // -----------------------------------------------------------------
        // USER discount codes
        // -----------------------------------------------------------------
        readCode: (context, { user_id, code, rate, pattern_code }) => {
            let url = `users/${user_id}/discount-codes/${code}?rate=${rate}`
            if (pattern_code) {
                url = `${url}&pattern_code=${pattern_code}`
            }
            return Vue.api.get(url)
                .then(response => {
                    return response.data.data
                })
                .catch(error => { throw error.response.data.error })
        }
    }
}